module.exports = __webpack_public_path__ + "static/img/component.d0738c40.svg";